import { createContext } from 'react';
import type { i18n } from 'i18next';

export type DynamicTranslationContext = {
  dynamicI18n: i18n;
  language: string | undefined;
  loadedNamespaces: Record<string, string[]>;
};

export const DynamicTranslationContext = createContext(
  {} as unknown as DynamicTranslationContext
);

DynamicTranslationContext.displayName = 'DynamicTranslationContext';
